import { sql } from "@-/com.npmjs.drizzle-orm";
import { toneNumbersPinyinText } from "@-/dev.improve.haniverse.database.schemas._lib.types.pinyin";
import { staticTable } from "@-/dev.improve.haniverse.database.schemas.static._lib.table";
import { wordTable } from "@-/dev.improve.haniverse.database.schemas.static.schema._tables.word";
import { bool, index as dbIndex, integer, text } from "@-/dev.improve.haniverse.lib.database.table";

/**
 * A word can have many definitions.
 */
export const wordDefinitionTable = staticTable(
  "word_definition",
  {
    wordId: integer("word_id")
      .notNull()
      .references(() => wordTable.id),

    /** English definition */
    definition: text("definition").notNull(),

    /** Space separated tone-numbered pinyin for this definition. */
    pinyin: toneNumbersPinyinText("pinyin").notNull(),

    /** Position of this definition within its source entry (0-based). */
    index: integer("index").notNull(),

    /** Whether this definition is applicable within Mainland China (PRC). */
    prcApplicable: bool("prc_applicable").notNull(),

    /** Whether this definition is applicable within Taiwan. */
    twApplicable: bool("tw_applicable").notNull(),

    /** Whether this definition is applicable within Hong Kong. */
    hkApplicable: bool("hk_applicable").notNull(),
  },
  (table) => [
    dbIndex("word_definition_word_id_idx").on(table.wordId),
    // SQLite LIKE is case-insensitive, so prefix searches require a NOCASE index.
    dbIndex("word_definition_pinyin_nocase_idx").on(sql`${table.pinyin} COLLATE NOCASE`),
  ],
);

export type WordDefinition = typeof wordDefinitionTable.$inferSelect;
